<div
  [formGroup]="controlFormGroup"
  class="phone-number__wrapper"
  [class.is-invalid-input]="hasErrors()"
  [class.margin-bottom-none]="!hasErrors()"
  [class.has-focus]="phoneInputHasFocus$ | async"
>
  <div class="flex-container">
    <!-- Open Country Selector Button -->
    <button
      class="phone-number__country-selector-trigger flex-child-shrink"
      type="button"
      [class.open]="isCountrySelectorOpen$ | async"
      (click)="controlName !== 'fax' && openCountryAutocomplete()"
    >
      <span
        class="flag-icon flag-icon-{{ selectedCountryCode.twoLetterCode }}"
        title="{{ selectedCountryCode.name }}"
      ></span>
    </button>
    <!-- Country Filter input -->
    <input
      placeholder="Enter your country"
      class="phone-number__country-filter-input"
      autocomplete="off"
      #countryFilterInput
      [class.flex-child-grow]="isCountrySelectorOpen$ | async"
      [class.hide]="(isCountrySelectorOpen$ | async) !== true"
      [formControl]="countryFilterList"
      [matAutocomplete]="countryAutocomplete"
    />
    <!-- Search Icon -->
    <i class="fa fa-search phone-number__search-icon align-self-middle"></i>
    <!-- Country Autocomplete -->
    <mat-autocomplete
      #countryAutocomplete="matAutocomplete"
      [displayWith]="displaySelectedCountry"
      (optionSelected)="onCountrySelected($event)"
      (closed)="onCountryAutocompleteClosed($event)"
    >
      <mat-option *ngFor="let country of filteredCountriesList$ | async" [value]="country">
        <span class="flag-icon flag-icon-{{ country.twoLetterCode }}"></span>
        <span class="mat-option__country-data">{{ country.name }} ({{ country.countryCode }})</span>
      </mat-option>
    </mat-autocomplete>

    <!-- Country Code Number -->
    <span class="phone-number__country-code flex-child-shrink">{{ selectedCountryCode.countryCode }}</span>
    <!-- Phone Number -->
    <input
      #phoneNumberInput
      ravOnlyNumbers
      [ravPhoneNumberFormatter]="selectedCountryCode$"
      [class.flex-child-grow]="(isCountrySelectorOpen$ | async) !== true"
      [class.hide]="isCountrySelectorOpen$ | async"
      [class.is-invalid-input]="hasErrors()"
      [name]="controlName"
      [placeholder]="placeholder || 'Enter ' + (controlName | controlNameToHuman | snakeCaseToHuman)"
      [formControlName]="controlName"
      [autocomplete]="autocomplete ? 'on' : 'off'"
      [attr.data-cy]="dataCy"
      (focus)="phoneNumberInputGotFocus(true)"
      (blur)="phoneNumberInputGotFocus(false)"
      autocomplete="off"
    />
  </div>
</div>
